import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { t } from 'i18next';

export const useGetIndirectTotalFieldsTableHeadings = () => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const INDIRECT_TOTAL_FIELDS = {
      NET_INCOME_PROFIT_FOR_PERIOD: {
        name: 'netIncomeProfitForPeriod',
        title: t('financialPlan.projectedCashFlow.inDirect.netIncomeProfitForPeriod'),
      },
      NET_CASH_PROVIDED_OPERATING_ACTIVITIES: {
        name: 'netCashProvidedOperatingActivities',
        title: t('financialPlan.projectedCashFlow.inDirect.netCashProvidedOperatingActivities'),
      },
    } as const;
    return INDIRECT_TOTAL_FIELDS;
  }, [t, i18n]);
};

export const INDIRECT_TOTAL_FIELDS = {
  NET_INCOME_PROFIT_FOR_PERIOD: {
    name: 'netIncomeProfitForPeriod',
    title: t('financialPlan.projectedCashFlow.inDirect.netIncomeProfitForPeriod'),
  },
  NET_CASH_PROVIDED_OPERATING_ACTIVITIES: {
    name: 'netCashProvidedOperatingActivities',
    title: t('financialPlan.projectedCashFlow.inDirect.netCashProvidedOperatingActivities'),
  },
} as const;
